import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

export const initialize = () => {
  if (!import.meta.env.PROD) {
    return
  }

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'chicken-web',
    env: import.meta.env.VITE_APPLICATION_ENV,
    forwardErrorsToLogs: false,
    sessionSampleRate: 100,
  })

  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'chicken-web',
    env: import.meta.env.VITE_APPLICATION_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    allowedTracingUrls: [
      {
        match: import.meta.env.VITE_SERVER_URL,
        propagatorTypes: ['datadog'],
      },
    ],
  })
}
